import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const TeaserSmallImages = () => {
  if (document.querySelectorAll('.teaser-small-images-section').length < 1) {
    return;
  }

  const network = document.querySelector('.teaser-small-images-section .network');

  function createParallaxTimeline(triggerSelector, startYPercent, endYPercent, scaleTo) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: triggerSelector,
            scrub: 1,
            pin: false,
        }
    });

    tl.fromTo(triggerSelector, {
        yPercent: startYPercent,
        scale: 1,
        ease: 'none'
    }, {
        yPercent: endYPercent,
        scale: scaleTo,
        ease: 'none'
    });

    return tl;
  }

  function parallaxEffect() {
    network ? createParallaxTimeline(network, -9, 9, 1) : null;
  }

  parallaxEffect();
};

export default TeaserSmallImages;